import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
const readImageFiles = (dataTransfer) => {
    if (!dataTransfer || !dataTransfer.files || dataTransfer.files.length === 0) {
        return [];
    }
    const files = [];
    for (let i = 0; i < dataTransfer.files.length; i += 1) {
        const file = dataTransfer.files.item(i);
        if (file && file.type && file.type.startsWith('image/')) {
            files.push(file);
        }
    }
    return files;
};
const insertImagesAtPosition = (editor, view, urls, pos) => {
    if (!urls.length) {
        return;
    }
    let insertPos = pos;
    if (typeof insertPos !== 'number') {
        insertPos = view.state.selection.from;
    }
    urls.forEach((src) => {
        if (!src) {
            return;
        }
        const imageCommand = editor.chain().focus();
        if (typeof insertPos === 'number') {
            imageCommand.setTextSelection(insertPos);
        }
        imageCommand.setImage({ src }).run();
    });
};
export const FileHandler = Extension.create({
    name: 'fileHandler',
    addProseMirrorPlugins() {
        const editor = this.editor;
        const handleImageFiles = this.options?.handleImageFiles;
        if (!handleImageFiles || typeof window === 'undefined') {
            return [];
        }
        return [
            new Plugin({
                key: new PluginKey('fileHandler'),
                props: {
                    handleDOMEvents: {
                        drop: (view, event) => {
                            const dragEvent = event;
                            const files = readImageFiles(dragEvent.dataTransfer);
                            if (!files.length) {
                                return false;
                            }
                            event.preventDefault();
                            event.stopPropagation();
                            const coords = {
                                left: dragEvent.clientX,
                                top: dragEvent.clientY,
                            };
                            const posAtCoords = view.posAtCoords(coords);
                            const pos = posAtCoords ? posAtCoords.pos : undefined;
                            handleImageFiles(files)
                                .then((urls) => {
                                insertImagesAtPosition(editor, view, urls, pos);
                            })
                                .catch(() => {
                            });
                            return true;
                        },
                        paste: (view, event) => {
                            const clipboardEvent = event;
                            const files = readImageFiles(clipboardEvent.clipboardData);
                            if (!files.length) {
                                return false;
                            }
                            event.preventDefault();
                            event.stopPropagation();
                            handleImageFiles(files)
                                .then((urls) => {
                                insertImagesAtPosition(editor, view, urls);
                            })
                                .catch(() => {
                            });
                            return true;
                        },
                    },
                },
            }),
        ];
    },
});
//# sourceMappingURL=file-handler.js.map